import { render } from "./Texts.vue?vue&type=template&id=ca8d841e"
const script = {}

import exportComponent from "/app/tmp/10eqs/V3/v2026.33.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__